import React from 'react';
import './Navigation.css'
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import img from '../../../images/logo/name-logo.png'

const Navigation = () => {
    return (
        <div>
            <Navbar collapseOnSelect expand="lg"  variant="dark">
  <Container >
  <Navbar.Brand href="#home">
      <img
        src={img}
        width="40"
        height="40"
        className="d-inline-block align-top"
        alt="React Bootstrap logo"
      />
    </Navbar.Brand>
  <Navbar.Brand className='brands' href="#home">Arman Corders</Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse className="justify-content-end" id="responsive-navbar-nav">
  <Nav >
      
      <Nav.Link href="#about">About</Nav.Link>
      <Nav.Link href="#projects">Projects</Nav.Link>
      <Nav.Link href="#contract">Contract</Nav.Link>
    </Nav>
  </Navbar.Collapse>
  </Container>
</Navbar>
        </div>
    );
};

export default Navigation;